import { useEffect } from 'react';
import { PaymentCycle_BIMap } from '../services/BiLogger/BiLoggerTypes';
import { AppStore } from '../stores/App.store';
import { isEligibleForVoucher } from '../utils';

export const useAppLoaded = (appStore: AppStore) => {
  useEffect(() => {
    const {
      appContext,
      currentCycle,
      currentProduct,
      productsPrices,
      planType,
      currentPlanInOfferingMode,
      intent,
      isDayful,
      appFlow,
    } = appStore;
    const {
      biLogger,
      fedopsLogger,
      currencyCode,
      currentPlanDetails,
      requestParamsMap,
    } = appContext;
    const abTesting = window.screen
      ? `width:${window.screen.width};height:${window.screen.height}; version: v3`
      : '';

    const appLoadedEvent = isDayful
      ? biLogger.logDayfulPlansPageLoadedBiEvent
      : biLogger.logPlansPageLoadedBiEvent;

    appLoadedEvent({
      abTesting,
      ppType: planType,
      cycle: PaymentCycle_BIMap[currentCycle],
      productId: currentProduct?.id,
      productGuid: currentProduct?.guid,
      pricing: productsPrices,
      currency: currencyCode,
      changePlanType: currentPlanInOfferingMode,
      currentProductId: currentPlanDetails?.planId ?? null,
      intent,
      intentDomainName:
        (isEligibleForVoucher(requestParamsMap.domainName) &&
          requestParamsMap.domainName) ||
        null,
      cartFlow: appFlow,
    });
    fedopsLogger.endAppRenderedInteraction();
  }, []);
};
